module.exports = __webpack_public_path__ + "static/media/scan@shortened.970ab70c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/scan@shortened.gif
// module id = 201
// module chunks = 0